export const LIMY_YAD2_TOKEN =
  'phc_RZgLIoU7R8us5QUz65UdOwbMurT8I6qRgINQhzdOKOL';

export const LIMY_DRUSHIM_TOKEN =
  'phc_1bQc8CGdgtbIVm6EhS8dUlrbjFRfHc18o3CVha34RAx';
